module.exports = fox._r("images/player/banners/guest_freeReg_large.png", __webpack_public_path__ + "_/_/_/root/images/player/banners/guest_freeReg_large.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/player/banners/guest_freeReg_large.png
// module id = 897
// module chunks = 4